module.exports = __webpack_public_path__ + "img/3.6ac6f762.jpg";